function init() {
  $('[required]').on('input', function() {
    var l = $('[required]').filter(function(index) { return !this.value }).length

    if (l == 0) {
      // console.log('Enabling...')
      $('.specialty-input').prop('disabled', '')
      $('.examination-input').prop('disabled', '')

      if ($("#examination").prop("selectedIndex") > 0) {
        $('input.timeslot-dt').prop('disabled', '')
      }
    } else {
      // console.log('Disabling...')
      $('.specialty-input').prop('disabled', 'true')
      $('.examination-input').prop('disabled', 'true')      
      $('input.timeslot-dt').prop('disabled', 'true')

      // 1. Remove timeslots radios.
      $('li.list-group-item').not('li.list-group-item-secondary').each(function(i) { $(this).find('span').remove() })
      // 2. Disable timeslots li's by greying them.
      $('li.list-group-item').not('li.list-group-item-secondary').each(function(i) { $(this).addClass('list-group-item-secondary') })
      // 3. Yes, I'm a genius.
    }
  })
}

$(document).ready(
  init()
);

$(document).on("turbolinks:load", function() {
  init()
});
